import { cn } from '@finn/ui-utils';

type Props = {
  className?: string;
  size?: 'small' | 'normal';
};

export const PriceInformation = ({ className, size }: Props) => (
  <div
    className={cn(
      '-mt-1 ml-1.5 font-light',
      size === 'small' ? 'text-[10px]' : 'text-xs',
      className
    )}
  >
    1
  </div>
);
